import { useCallback, useMemo, useState } from "react";

import { truncateText } from "../../../../../../../utils";
import { useResponsive } from "../../../../../../../hooks/useResponsive";
import { useBoards } from "../../../../../../../reactQuery/boards";
import { getResponseData } from "../../../../../../../reactQuery/response";

export function useChangeBoardState(card) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedTargetBoard, setSelectedTargetBoard] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const isMobile = useResponsive("down", "md");
  const { boards } = useBoards();
  const cardData = useMemo(() => getResponseData(card, card ?? {}), [card]);
  const allBoards = useMemo(() => getResponseData(boards, []), [boards]);
  const boardData = cardData ?? {};
  const open = Boolean(anchorEl);

  const filteredBoards = useMemo(
    () =>
      allBoards
        .filter(
          (item) =>
            item?.board_name &&
            item?.is_archive === false &&
            item?.board_id !== boardData?.board?.board_id
        )
        .sort((left, right) => left.board_name.localeCompare(right.board_name)),
    [allBoards, boardData?.board?.board_id]
  );

  const handleAnchorClick = useCallback((event) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleMenuClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleSelectBoard = useCallback((board) => {
    setSelectedTargetBoard(board);
    setIsDialogOpen(true);
    setAnchorEl(null);
  }, []);

  const handleDialogClose = useCallback((value) => {
    setIsDialogOpen(value);
  }, []);

  return {
    boardData,
    currentBoardLabel: truncateText(boardData?.board?.board_name || "", 25),
    filteredBoards,
    handleAnchorClick,
    handleDialogClose,
    handleMenuClose,
    handleSelectBoard,
    isDialogOpen,
    isMobile,
    open,
    selectedTargetBoard,
    targetBoardLabel: truncateText(selectedTargetBoard?.board_name || "", 25),
    anchorEl,
  };
}
